import React from 'react';
import { FormattedMessage } from 'react-intl';

import { messages } from '../messages';
import { transferOrderGridProperties } from '../../data/transfer-order-properties';
import type { GridColumn } from './types';

const name = <FormattedMessage {...messages.destinationWarehouseColumnHeader} />;

export const destinationWarehouseColumn: GridColumn = {
  name,
  render: (data) => {
    const { destinationWarehouseName } = data;
    return <span>{(destinationWarehouseName as string) || '-'}</span>;
  },
  id: transferOrderGridProperties.destinationWarehouseName,
};
